import React from 'react'
import PropTypes from 'prop-types'

import { getInstallationFeeAmount, hasOneTimeInstallationFee } from '../../utils'
import LineItem from '../../LineItem'

const InstallationFee = ({ cart, dataTestId, lang, translations }) => {
  const installationFee = getInstallationFeeAmount(cart)
  if (!hasOneTimeInstallationFee(cart)) {
    return null
  }

  return (
    <LineItem
      text={translations.oneTimeInstallationFee}
      cost={installationFee}
      lang={lang}
      annotationInline
      dataIdAttribute={`${dataTestId}-price-summary-hs-installation-fee`}
    />
  )
}

InstallationFee.propTypes = {
  cart: PropTypes.object.isRequired,
  dataTestId: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired
}

export default InstallationFee
